/* import __COLOCATED_TEMPLATE__ from './main.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();